import {
  Sale,
  SaleLineItem,
} from "@towersystems/roam-common/lib/generated-types";
import { useCallback } from "react";
import { FlatList } from "react-native";
import { Divider } from "@towersystems/roam-common-native";
import { LineItem } from "./components";

export interface SaleLineItemsSummaryProps {
  sale: Sale;
  onItemPress?: (item: SaleLineItem) => void;
}

export const SaleLineItemsSummary = ({
  sale,
  onItemPress,
}: SaleLineItemsSummaryProps) => {
  const renderItem = useCallback(
    ({ item }: { item: SaleLineItem }) => {
      return (
        <LineItem key={item.id} lineItem={item} onItemPress={onItemPress} />
      );
    },
    [onItemPress]
  );
  return (
    <FlatList
      style={{ overflow: "visible" }}
      scrollEnabled={true}
      ItemSeparatorComponent={Divider}
      data={sale.lineItems}
      renderItem={renderItem}
    ></FlatList>
  );
};
